import React, { useState } from 'react';
import '../CardContent.scss';
import {
    Placeholder, RichText,
    useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import './NewsletterContent.scss';

export const Input = (props: {
  placeholder: { value: string };
  Value?: string;
  setValue?: Function;
  icon?: string;
  id?: string;
  iconClick?: Function;
}) => {
  const [focused, setFocused] = useState(false);
  return (
    <div className={'CardContent__input_box'}>
      <input
        type={'text'}
        id={props.id && props.id}
        value={props.Value && props.Value}
        className={'CardContent__input pt-16'}
        name={'newsName'}
        placeholder={''}
        onChange={(e) => props.setValue(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <label
        htmlFor={'newsName'}
        className={`CardContent__input_placeholder ${
          (focused || props.Value !== '') && 'CardContent__input_focused'
        }`}
      >
        {props?.placeholder?.value}
      </label>
      <span
        className={`icon ${props.icon && props.icon} CardContent__input_icon`}
        onClick={() => props?.iconClick()}
      />
    </div>
  );
};

const NewsletterContent = (props: {
  title: { value: string };
  icon?: { value: string };
  content: { value: string };
  formPlaceholder: { value: string };
  linkTitle: { value: string };
}) => {
  const sitecoreContext = useSitecoreContext();
  return (
    <section className={'NewsletterContent CardContent__section_container'}>
      <div className={'CardContent__title_section'}>
        <h3>{props?.title?.value}</h3>
        <span
          className={`icon ${props.icon && props.icon.value} CardContent__icon`}
        />
      </div>
      <RichText className={'CardContent__description'} field={props?.content}  />
      <p className={'CardContent__form_placeholder'}>
        {props?.formPlaceholder?.value}
      </p>
      <Placeholder
        name="jss-newsletter-form"
        rendering={(sitecoreContext.sitecoreContext as any).route}
      />
    </section>
  );
};
export default NewsletterContent;
